import React, { Component } from 'react'
import * as PropTypes from "prop-types";

import { Form, Modal, Radio, Row, Col, message, Progress } from "antd";
import { DatePickerWithMask } from '../../../components';

import moment from 'moment';

import { timeService, recalculateSchedulesService } from '../../../redux/services';

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Recalculate extends Component {
  static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
	};

  constructor(props) {
		super(props);

		this.state = {
      isSending: false,
      recalcular: true,
      progress: 0,
      horario: [],
      manter_jornada_original: true,
    };
	}

  onOpen = (uuid) => {
    timeService.show({ uuid })
      .then((response) => {
        const item = response.data.data[0];

        this.setState({
          horario: [item.id],
        })
      })
      .catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
  };

  onClose = () => {
		// Callback
		this.props.onComplete();
	};

  onFinish = async () => {
    this.startProgress();

    try {
      const values = await this.form.validateFields();
      this.setState({ isSending: true });
  
      const { recalcular, horario, manter_jornada_original } = this.state;
      const { data: dados } = this.props;
      
      const data = {
        ...values,
        data_inicial: moment(values.data_inicial).format('YYYY-MM-DD'),
        data_final: moment(values.data_final).format('YYYY-MM-DD'),
        horarios: horario,
        manter_jornada_original
      };
  
      try {
        await timeService.edit(dados);
        this.setState({ isSending: false });
        if (!recalcular) this.props.onComplete();
      } catch (error) {
        this.setState({ isSending: false });
        Modal.error({
          title: "Ocorreu um erro!",
          content: String(error),
        });
        return;
      }
  
      if (recalcular) {
        this.setState({ isSending: true });
        try {
          await recalculateSchedulesService.recalculate(data);
          this.setState({ isSending: false });
          this.props.onComplete();
        } catch (error) {
          this.setState({ isSending: false });
          Modal.error({
            title: "Ocorreu um erro!",
            content: String(error),
          });
        }
      } else {
        this.setState({ isSending: false });
        this.props.onClose();
      }
    } catch (error) {
      this.setState({ isSending: false });
      message.error("Erro na validação dos campos:", error);
    }
  };

  startProgress = () => {
    let steps = [5, 10, 15, 25, 30, 40, 50, 75, 90, 99];
    let index = 0;

    this.setState({ progress: 0, isSending: true });

    this.progressInterval = setInterval(() => {
      if (index < steps.length) {
        this.setState({ progress: steps[index] });
        index++;
      } else {
        clearInterval(this.progressInterval);
      }
    }, 5000);
  }; 

  validateEndDate = async (_, value) => {
    if (value && (typeof value === 'string' || !value.isValid())) {
      return Promise.reject(new Error('Data inválida.'));
    }
    const dataInicial = this.form.getFieldValue('data_inicial');
    if (value && dataInicial && moment(value).startOf('day').diff(moment(dataInicial).startOf('day'), 'years', true) > 1) {
      return Promise.reject(new Error('Periodo selecionado muito longo, selecione um periodo menor.'));
    }
    if (!value || !dataInicial || value.endOf('day').isSameOrAfter(dataInicial)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Data final deve ser maior ou igual à data inicial.'));
  };

  validateStartDate = async (_, value) => {
    if (value && (typeof value === 'string' || !value.isValid())) {
      return Promise.reject(new Error('Data inválida.'));
    }
    const dataFinal = this.form.getFieldValue('data_final');
    if (value && dataFinal && moment(dataFinal).startOf('day').diff(moment(value).startOf('day'), 'years', true) > 1) {
      return Promise.reject(new Error('Periodo selecionado muito longo, selecione um periodo menor.'));
    }
    if (!value || !dataFinal || value.startOf('day').isSameOrBefore(dataFinal)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Data inicial deve ser maior ou igual à data final.'));
  };
  
  render() {
    const { visible } = this.props;

    const { isSending } = this.state;

    return (
      <Modal
        visible={visible}
        title="Recalcular Horários"
        keyboard={false}
        centered
        destroyOnClose={true}
        maskClosable={false}
        closable={false}
        width={500}
        okText={this.state.recalcular ? "Recalcular" : "Finalizar"}
        onOk={this.onFinish}
        confirmLoading={isSending}
        onCancel={() => this.props.onCancel?.()}
        className="modal-recalcular"
      >
        <Form
          ref={el => this.form = el}
          id={formId}
          layout="vertical"
          scrollToFirstError
          onFinish={this.onFinish}
          initialValues={{}}
        >
          <p>
            Atenção: A modificação que você fez aqui pode alterar cálculos de
            horas de dias anteriores. O que deseja fazer?
          </p>
          <Radio
            checked={this.state.recalcular}
            onChange={() => this.setState({ recalcular: true })}
          >
            Recalcular marcações de dias anteriores.
          </Radio>
          <Row gutter={16}>
            <Col xs={12}>
              <DatePickerWithMask
                name="data_inicial"
                label="Data Início"
                rules={[
                  { required: this.state.recalcular, message: 'Campo obrigatório.' },
                  { validator: this.validateStartDate }
                ]}
              />
            </Col>
            <Col xs={12}>
              <DatePickerWithMask
                name="data_final"
                label="Data Fim"
                rules={[
                  { required: this.state.recalcular, message: 'Campo obrigatório.' },
                  { validator: this.validateEndDate }
                ]}
              />
            </Col>
          </Row>
          <Radio
            checked={!this.state.recalcular}
            onChange={() => this.setState({ recalcular: false })}
          >
            Aplicar esta modificação somente para as novas marcações.
          </Radio>
          {isSending && <Progress percent={this.state.progress} />}
        </Form>
      </Modal>
    )
  }
}

export default Recalculate;
